import type { DaysOfWeekEnum } from 'src/common/external/bambi-api/routesApi';

export const localDaysToApiDaysOfWeekMap: Record<string, DaysOfWeekEnum> = {
  Sunday: 'sun',
  Monday: 'mon',
  Tuesday: 'tue',
  Wednesday: 'wed',
  Thursday: 'thu',
  Friday: 'fri',
  Saturday: 'sat',
};

export const apiDaysOfWeekToLocalDaysMap: Record<DaysOfWeekEnum, string> = {
  sun: 'Sunday',
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
};

export function convertDaysOfWeekToLocalDays(daysOfWeek: DaysOfWeekEnum[]) {
  return daysOfWeek.map((day) => apiDaysOfWeekToLocalDaysMap[day]);
}

export function convertLocalDaysToDaysOfWeek(daysOfWeek: string[]) {
  return daysOfWeek.map((day) => localDaysToApiDaysOfWeekMap[day]);
}
